import {
  activities,
  addPost,
  alert,
  alertPromotional,
  alertTriangle,
  alertTriangleAlt,
  anforaFill,
  anforaStroke,
  archive,
  arrowBackward,
  arrowCircle,
  arrowDown,
  arrowDownward,
  arrowForward,
  arrowLeft,
  arrowReorder,
  arrowRight,
  arrowUp,
  arrowUpward,
  at,
  attachment,
  avatarCouple,
  bellPlus,
  basket,
  blur,
  bold,
  book,
  bookmark,
  box,
  boxDownload,
  browser,
  building,
  calendar,
  camera,
  cancel,
  cartAdd,
  chart,
  chatBubbleOutline,
  checkCircle,
  checkDouble,
  checkSingle,
  chronometer,
  city,
  clock,
  clockAlarm,
  clockTimer,
  close,
  closeCircle,
  cloudDownload,
  code,
  contactCard,
  couple,
  coupon,
  creditCard,
  discount,
  documentSingle,
  documents,
  dragIndicator,
  edit,
  errorStandard,
  etc,
  exclamationMark,
  exclamationMarkHexagon,
  exclamationMarkHexagonFillIcon,
  exclamationMarkTriangleOutline,
  exit,
  externalLink,
  filter,
  flashlight,
  flower,
  folder,
  formatOfList,
  gear,
  giftCard,
  globe,
  grid,
  hand,
  heart,
  home,
  hourglass,
  http,
  hub,
  illustration,
  info,
  italic,
  key,
  landscape,
  letterForward,
  letterOpen,
  lift,
  light,
  locationPin,
  locker,
  luggage,
  magazine,
  megaPhone,
  message,
  messageOff,
  minus,
  minusCircle,
  money,
  moon,
  more,
  notebook,
  notifications,
  order,
  paperAirPlane,
  person,
  personAccessibility,
  personAdd,
  personExchange,
  personRunning,
  phone,
  photo,
  play,
  playCircleOutline,
  plus,
  plusCircle,
  questionMarkCircle,
  quotesClose,
  quotesOpen,
  rateDislike,
  rateLike,
  receipt,
  rectangleArrowRight,
  renew,
  resize,
  review,
  reward,
  rotate,
  route,
  scribble,
  search,
  settings,
  share,
  shoppingBag,
  shoppingCart,
  smartphone,
  smile,
  socialFacebook,
  socialFacebookBox,
  socialGithub,
  socialGoogle,
  socialInstagram,
  socialLinkedin,
  socialTwitter,
  socialWhatsapp,
  socialYoutube,
  spa,
  star,
  starCircle,
  starOutline,
  store,
  strikeThrough,
  sun,
  swap,
  tablet,
  textCheck,
  thumbUpOutline,
  tooltip,
  touchscreen,
  trash,
  tree,
  threeLinesHorizontal,
  truck,
  undo,
  upload,
  visibilityOff,
  visibilityOn,
  waves,
  copy,
  trendingUp,
  storeFront,
  pix,
  promotionCategory,
  launchCategory,
  perfurmeCategory,
  bodyAndBathCategory,
  makeUpCategory,
  hairCategory,
  houseAndPetsCategory,
  selectedForYouCategory,
} from './Icon.data';
import type { IconComponentProps, IconProps } from './Icon.d';
import StyledIcon from './Icon.styles';

const CustomIconWithPaths = function CustomIconWithPaths({
  path,
  size,
  ...rest
}: IconComponentProps) {
  return (
    <StyledIcon
      data-testid="icon"
      size={size}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <path d={path} fillRule="evenodd" />
    </StyledIcon>
  );
};

CustomIconWithPaths.defaultProps = {
  viewBox: '0 0 24 24',
  size: 'm',
};

const IconHandler = (path: string) =>
  function Icon(props: IconProps) {
    return <CustomIconWithPaths path={path} {...props} />;
  };

const ArrowCircleIconHandler = (path: string) =>
  function ArrowCircleIcon(props: IconProps) {
    return <CustomIconWithPaths path={path} viewBox="0 0 40 55" {...props} />;
  };

const CopyIconHandler = (path: string) =>
  function Icon(props: IconProps) {
    return <CustomIconWithPaths path={path} viewBox="0 0 16 17" {...props} />;
  };

export const SkincareCategoryIcon = () => (
  <svg width="28" height="32" viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.2696 5.39266C8.19713 5.39266 6.7645 7.06654 7.05848 7.95037C7.06864 7.98091 7.09806 7.99996 7.13024 7.99996H20.9877C21.0286 7.99996 21.0632 7.96759 21.067 7.92686C21.5456 2.84231 15.2954 0.981 14.188 0.812779C14.1284 0.803738 14.092 0.862971 14.1146 0.918771C14.4931 1.85359 15.084 5.39266 12.2696 5.39266Z" />
    <mask fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.35933 16.8001V13.4004H22.6687V16.8001H5.35933ZM2.35933 16.8001V11.4004C2.35933 10.8481 2.80705 10.4004 3.35933 10.4004H24.6687C25.2209 10.4004 25.6687 10.8481 25.6687 11.4004V16.8001H26.3854C27.269 16.8001 27.9854 17.5165 27.9854 18.4001V27.9999C27.9854 29.7673 26.5527 31.1999 24.7854 31.1999H3.21416C1.44685 31.1999 0.0141602 29.7673 0.0141602 27.9999V18.4001C0.0141602 17.5165 0.730505 16.8001 1.61416 16.8001H2.35933ZM9.35213 23.6004C9.35213 22.9376 9.88938 22.4004 10.5521 22.4004H17.4759C18.1386 22.4004 18.6759 22.9376 18.6759 23.6004C18.6759 24.2631 18.1386 24.8004 17.4759 24.8004H10.5521C9.88938 24.8004 9.35213 24.2631 9.35213 23.6004Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.35933 16.8001V13.4004H22.6687V16.8001H5.35933ZM2.35933 16.8001V11.4004C2.35933 10.8481 2.80705 10.4004 3.35933 10.4004H24.6687C25.2209 10.4004 25.6687 10.8481 25.6687 11.4004V16.8001H26.3854C27.269 16.8001 27.9854 17.5165 27.9854 18.4001V27.9999C27.9854 29.7673 26.5527 31.1999 24.7854 31.1999H3.21416C1.44685 31.1999 0.0141602 29.7673 0.0141602 27.9999V18.4001C0.0141602 17.5165 0.730505 16.8001 1.61416 16.8001H2.35933ZM9.35213 23.6004C9.35213 22.9376 9.88938 22.4004 10.5521 22.4004H17.4759C18.1386 22.4004 18.6759 22.9376 18.6759 23.6004C18.6759 24.2631 18.1386 24.8004 17.4759 24.8004H10.5521C9.88938 24.8004 9.35213 24.2631 9.35213 23.6004Z"
    />
    <path
      d="M5.35933 13.4004V12.6004H4.55933V13.4004H5.35933ZM5.35933 16.8001H4.55933V17.6001H5.35933V16.8001ZM22.6687 13.4004H23.4687V12.6004H22.6687V13.4004ZM22.6687 16.8001V17.6001H23.4687V16.8001H22.6687ZM2.35933 16.8001V17.6001H3.15933V16.8001H2.35933ZM25.6687 16.8001H24.8687V17.6001H25.6687V16.8001ZM4.55933 13.4004V16.8001H6.15933V13.4004H4.55933ZM22.6687 12.6004H5.35933V14.2004H22.6687V12.6004ZM23.4687 16.8001V13.4004H21.8687V16.8001H23.4687ZM22.6687 16.0001H5.35933V17.6001H22.6687V16.0001ZM1.55933 11.4004V16.8001H3.15933V11.4004H1.55933ZM3.35933 9.60039C2.36522 9.60039 1.55933 10.4063 1.55933 11.4004H3.15933C3.15933 11.2899 3.24888 11.2004 3.35933 11.2004V9.60039ZM24.6687 9.60039H3.35933V11.2004H24.6687V9.60039ZM26.4687 11.4004C26.4687 10.4063 25.6628 9.60039 24.6687 9.60039V11.2004C24.7791 11.2004 24.8687 11.2899 24.8687 11.4004H26.4687ZM26.4687 16.8001V11.4004H24.8687V16.8001H26.4687ZM26.3854 16.0001H25.6687V17.6001H26.3854V16.0001ZM28.7854 18.4001C28.7854 17.0746 27.7108 16.0001 26.3854 16.0001V17.6001C26.8272 17.6001 27.1854 17.9583 27.1854 18.4001H28.7854ZM28.7854 27.9999V18.4001H27.1854V27.9999H28.7854ZM24.7854 31.9999C26.9945 31.9999 28.7854 30.2091 28.7854 27.9999H27.1854C27.1854 29.3254 26.1108 30.3999 24.7854 30.3999V31.9999ZM3.21416 31.9999H24.7854V30.3999H3.21416V31.9999ZM-0.78584 27.9999C-0.78584 30.2091 1.00502 31.9999 3.21416 31.9999V30.3999C1.88868 30.3999 0.81416 29.3254 0.81416 27.9999H-0.78584ZM-0.78584 18.4001V27.9999H0.81416V18.4001H-0.78584ZM1.61416 16.0001C0.288678 16.0001 -0.78584 17.0746 -0.78584 18.4001H0.81416C0.81416 17.9583 1.17233 17.6001 1.61416 17.6001V16.0001ZM2.35933 16.0001H1.61416V17.6001H2.35933V16.0001ZM10.5521 21.6004C9.44756 21.6004 8.55213 22.4958 8.55213 23.6004H10.1521C10.1521 23.3795 10.3312 23.2004 10.5521 23.2004V21.6004ZM17.4759 21.6004H10.5521V23.2004H17.4759V21.6004ZM19.4759 23.6004C19.4759 22.4958 18.5804 21.6004 17.4759 21.6004V23.2004C17.6968 23.2004 17.8759 23.3795 17.8759 23.6004H19.4759ZM17.4759 25.6004C18.5804 25.6004 19.4759 24.7049 19.4759 23.6004H17.8759C17.8759 23.8213 17.6968 24.0004 17.4759 24.0004V25.6004ZM10.5521 25.6004H17.4759V24.0004H10.5521V25.6004ZM8.55213 23.6004C8.55213 24.7049 9.44756 25.6004 10.5521 25.6004V24.0004C10.3312 24.0004 10.1521 23.8213 10.1521 23.6004H8.55213Z"
      mask="url(#path-2-inside-1_14152_105174)"
    />
  </svg>
);

export const Activities = IconHandler(activities);
export const AddPost = IconHandler(addPost);
export const Alert = IconHandler(alert);
export const AlertPromotional = IconHandler(alertPromotional);
export const AlertTriangle = IconHandler(alertTriangle);
export const AlertTriangleAlt = IconHandler(alertTriangleAlt);
export const AnforaFill = IconHandler(anforaFill);
export const AnforaStroke = IconHandler(anforaStroke);
export const Archive = IconHandler(archive);
export const ArrowBackward = IconHandler(arrowBackward);
export const ArrowCircle = ArrowCircleIconHandler(arrowCircle);
export const ArrowDown = IconHandler(arrowDown);
export const ArrowDownward = IconHandler(arrowDownward);
export const ArrowForward = IconHandler(arrowForward);
export const ArrowLeft = IconHandler(arrowLeft);
export const ArrowReorder = IconHandler(arrowReorder);
export const ArrowRight = IconHandler(arrowRight);
export const ArrowUp = IconHandler(arrowUp);
export const ArrowUpward = IconHandler(arrowUpward);
export const At = IconHandler(at);
export const Attachment = IconHandler(attachment);
export const AvatarCouple = IconHandler(avatarCouple);
export const Basket = IconHandler(basket);
export const BellPlus = IconHandler(bellPlus);
export const Blur = IconHandler(blur);
export const Bold = IconHandler(bold);
export const Book = IconHandler(book);
export const Bookmark = IconHandler(bookmark);
export const Box = IconHandler(box);
export const BoxDownload = IconHandler(boxDownload);
export const Browser = IconHandler(browser);
export const Building = IconHandler(building);
export const Calendar = IconHandler(calendar);
export const Camera = IconHandler(camera);
export const Cancel = IconHandler(cancel);
export const CartAdd = IconHandler(cartAdd);
export const Chart = IconHandler(chart);
export const ChatBubbleOutline = IconHandler(chatBubbleOutline);
export const CheckCircle = IconHandler(checkCircle);
export const CheckDouble = IconHandler(checkDouble);
export const CheckSingle = IconHandler(checkSingle);
export const Chronometer = IconHandler(chronometer);
export const City = IconHandler(city);
export const Clock = IconHandler(clock);
export const ClockAlarm = IconHandler(clockAlarm);
export const ClockTimer = IconHandler(clockTimer);
export const Close = IconHandler(close);
export const CloseCircle = IconHandler(closeCircle);
export const CloudDownload = IconHandler(cloudDownload);
export const Code = IconHandler(code);
export const ContactCard = IconHandler(contactCard);
export const Couple = IconHandler(couple);
export const Coupon = IconHandler(coupon);
export const CreditCard = IconHandler(creditCard);
export const Discount = IconHandler(discount);
export const DocumentSingle = IconHandler(documentSingle);
export const Documents = IconHandler(documents);
export const DragIndicator = IconHandler(dragIndicator);
export const Edit = IconHandler(edit);
export const ErrorStandard = IconHandler(errorStandard);
export const Etc = IconHandler(etc);
export const ExclamationMark = IconHandler(exclamationMark);
export const ExclamationMarkHexagon = IconHandler(exclamationMarkHexagon);
export const ExclamationMarkHexagonFillIcon = IconHandler(exclamationMarkHexagonFillIcon);
export const ExclamationMarkTriangleOutline = IconHandler(exclamationMarkTriangleOutline);
export const Exit = IconHandler(exit);
export const ExternalLink = IconHandler(externalLink);
export const Filter = IconHandler(filter);
export const Flashlight = IconHandler(flashlight);
export const Flower = IconHandler(flower);
export const Folder = IconHandler(folder);
export const FormatOfList = IconHandler(formatOfList);
export const Gear = IconHandler(gear);
export const GiftCard = IconHandler(giftCard);
export const Globe = IconHandler(globe);
export const Grid = IconHandler(grid);
export const Hand = IconHandler(hand);
export const Heart = IconHandler(heart);
export const Home = IconHandler(home);
export const Hourglass = IconHandler(hourglass);
export const Http = IconHandler(http);
export const Hub = IconHandler(hub);
export const Illustration = IconHandler(illustration);
export const Info = IconHandler(info);
export const Italic = IconHandler(italic);
export const Key = IconHandler(key);
export const Landscape = IconHandler(landscape);
export const LetterForward = IconHandler(letterForward);
export const LetterOpen = IconHandler(letterOpen);
export const Lift = IconHandler(lift);
export const Light = IconHandler(light);
export const LocationPin = IconHandler(locationPin);
export const Locker = IconHandler(locker);
export const Luggage = IconHandler(luggage);
export const Magazine = IconHandler(magazine);
export const MegaPhone = IconHandler(megaPhone);
export const Message = IconHandler(message);
export const MessageOff = IconHandler(messageOff);
export const Minus = IconHandler(minus);
export const MinusCircle = IconHandler(minusCircle);
export const Money = IconHandler(money);
export const Moon = IconHandler(moon);
export const More = IconHandler(more);
export const Notebook = IconHandler(notebook);
export const Notifications = IconHandler(notifications);
export const Order = IconHandler(order);
export const PaperAirPlane = IconHandler(paperAirPlane);
export const Person = IconHandler(person);
export const PersonAccessibility = IconHandler(personAccessibility);
export const PersonAdd = IconHandler(personAdd);
export const PersonExchange = IconHandler(personExchange);
export const PersonRunning = IconHandler(personRunning);
export const Phone = IconHandler(phone);
export const Photo = IconHandler(photo);
export const Play = IconHandler(play);
export const PlayCircleOutline = IconHandler(playCircleOutline);
export const Plus = IconHandler(plus);
export const PlusCircle = IconHandler(plusCircle);
export const QuestionMarkCircle = IconHandler(questionMarkCircle);
export const QuotesClose = IconHandler(quotesClose);
export const QuotesOpen = IconHandler(quotesOpen);
export const RateDislike = IconHandler(rateDislike);
export const RateLike = IconHandler(rateLike);
export const Receipt = IconHandler(receipt);
export const RectangleArrowRight = IconHandler(rectangleArrowRight);
export const Renew = IconHandler(renew);
export const Resize = IconHandler(resize);
export const Review = IconHandler(review);
export const Reward = IconHandler(reward);
export const Rotate = IconHandler(rotate);
export const Route = IconHandler(route);
export const Scribble = IconHandler(scribble);
export const Search = IconHandler(search);
export const Settings = IconHandler(settings);
export const Share = IconHandler(share);
export const ShoppingBag = IconHandler(shoppingBag);
export const ShoppingCart = IconHandler(shoppingCart);
export const Smartphone = IconHandler(smartphone);
export const Smile = IconHandler(smile);
export const SocialFacebook = IconHandler(socialFacebook);
export const SocialFacebookBox = IconHandler(socialFacebookBox);
export const SocialGithub = IconHandler(socialGithub);
export const SocialGoogle = IconHandler(socialGoogle);
export const SocialInstagram = IconHandler(socialInstagram);
export const SocialLinkedin = IconHandler(socialLinkedin);
export const SocialTwitter = IconHandler(socialTwitter);
export const SocialWhatsapp = IconHandler(socialWhatsapp);
export const SocialYoutube = IconHandler(socialYoutube);
export const Spa = IconHandler(spa);
export const Star = IconHandler(star);
export const StarCircle = IconHandler(starCircle);
export const StarOutline = IconHandler(starOutline);
export const Store = IconHandler(store);
export const StrikeThrough = IconHandler(strikeThrough);
export const Sun = IconHandler(sun);
export const Swap = IconHandler(swap);
export const Tablet = IconHandler(tablet);
export const TextCheck = IconHandler(textCheck);
export const ThumbUpOutline = IconHandler(thumbUpOutline);
export const Tooltip = IconHandler(tooltip);
export const Touchscreen = IconHandler(touchscreen);
export const Trash = IconHandler(trash);
export const Tree = IconHandler(tree);
export const TreeLinesHorizontal = IconHandler(threeLinesHorizontal);
export const Truck = IconHandler(truck);
export const Undo = IconHandler(undo);
export const Upload = IconHandler(upload);
export const VisibilityOff = IconHandler(visibilityOff);
export const VisibilityOn = IconHandler(visibilityOn);
export const Waves = IconHandler(waves);
export const Copy = CopyIconHandler(copy);
export const TrendingUp = IconHandler(trendingUp);
export const StoreFront = IconHandler(storeFront);
export const Pix = IconHandler(pix);
export const PromotionCategory = IconHandler(promotionCategory);
export const LaunchCategory = IconHandler(launchCategory);
export const PerfurmeCategory = IconHandler(perfurmeCategory);
export const BodyAndBathCategory = IconHandler(bodyAndBathCategory);
export const MakeUpCategory = IconHandler(makeUpCategory);
export const HairCategory = IconHandler(hairCategory);
export const HouseAndPetsCategory = IconHandler(houseAndPetsCategory);
export const SelectedForYouCategory = IconHandler(selectedForYouCategory);
